import { Components, Theme } from '@mui/material';

export const MuiLink: Components<Theme>['MuiLink'] = {
  defaultProps: {
    draggable: false,
  },
  styleOverrides: {
    root: {
      WebkitUserDrag: 'none',
      WebkitTouchCallout: 'none',
    },
  },
};
